import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";

const token = localStorage.getItem('authToken');

class EditMagzines extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null, // Image file
      pdfInput: null,  // PDF file
      title: "",
      currentImageUrl: null,
      currentPdfUrl: null,
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      id: null,
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match params found.");
    }
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/magazines/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (response) {
      this.setState({
          title: response.data?.data?.title || "",
          currentImageUrl: response.data?.data?.image ? `https://uma-classees.blr1.digitaloceanspaces.com/${response.data?.data?.image}` : null,
          currentPdfUrl: response.data?.data?.pdf ? `https://marwadi-pdf-bucket.s3.ap-south-1.amazonaws.com/${response.data?.data?.pdf}` : null,
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };

  handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handlePdfChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= this.state.maxSize) {
      this.setState({
        pdfInput: file,
        currentPdfUrl: URL.createObjectURL(file), // Update current PDF URL to show the new PDF
      });
    } else {
      this.setState({ errors: [`${file.name} is too large, please select a file smaller than 5MB.`] });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    this.setState({ submeet: true });

    const { textInput, pdfInput, title } = this.state;

    if (!title) {
      return;
    }

    try {
      const formData = new FormData();
      if (textInput) formData.append("image", textInput);
      if (pdfInput) formData.append("pdf", pdfInput);
      formData.append("title", title);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/magazines/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push("/magazines-list");
        }, 2000);
      }
  
      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { textInput, pdfInput, title, currentImageUrl, currentPdfUrl, submeet, submissionStatus, isLoading } = this.state;
    const isTitleValid = title.trim().length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Magazines</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet }`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {/* {!isTitleValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )} */}
              </div>

              <div className="form-group">
                <label>Category Image</label>
              
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet }`}
                  name="textInput"
                  onChange={this.handleImageChange}
                />
                {/* {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null} */}
              </div>

              <div className="form-group">
                <label>Category PDF</label>
              
                {currentPdfUrl && (
                  <div>
                    <a href={currentPdfUrl} target="_blank" rel="noopener noreferrer">View Current PDF</a>
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!pdfInput && submeet }`}
                  name="pdfInput"
                  onChange={this.handlePdfChange}
                />
                {/* {!pdfInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null} */}
              </div>

              {submissionStatus === "success" && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit" disabled={isLoading}>
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditMagzines));
